<template>
  <v-container v-if="category" style="margin-top:0px; padding-top:0px;">

    <!-- <v-img :src="category.image_url"></v-img> -->

    <v-row>
      <v-col offset-xs="1" xs="10" offset-sm="2" sm="8" offset-lg="2" lg="8" class="pt-0 pb-0">

        <v-row>
          <v-col>
            <h1 align="left" style="font-size:20pt;">{{category.name}}</h1>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="left">
            <p style="font-size:10pt;" v-html="category.description"></p>
          </v-col>
        </v-row>
        <br>
        <br>
        <transition name="fade-transition" mode="out-in">
          <product-list presentationMode="grid" :products="products"></product-list>
        </transition>
        <!-- <v-row v-else>
          <b>Kategorien indeholder igen produkter.</b>
        </v-row> -->

      </v-col>
     </v-row>


  </v-container>
</template>

<script>
// @ is an alias to /src
import ProductList from '@/components/ProductList.vue';
import CategoryService from "@/services/CategoryService.js"
import ProductService from "../services/ProductService.js"

export default {
  name: 'home',
  components: {
    ProductList,
  },
  data: () => ({
    category: null,
    products: null
  }),
  mounted () {
    this.getCategoryBySlug(this.$route.params.category_slug)
  },
  methods: {
    async getSubCategories(parent_id) {
      CategoryService.methods.getSubCategories(parent_id)
      .then(listItems => {
          store.commit('mutateMenuItems', listItems);
          this.items = store.state.app.menuItems
       }).catch(error => {
         console.log(error);
       })
    },
    async getCategoryBySlug(category_slug) {
      CategoryService.methods.getCategoryBySlug(category_slug)
      .then(category => {
        this.category = category;
        console.log(category);
        this.getProductsByCategory (category.id);
       }).catch(error => {
         console.log(error);
       })
    },
    getProductsByCategory (category_id) {
      ProductService.getProductsByCategory(category_id)
        .then(products => {
          this.products = products
       }).catch(error => {
         console.log(error);
       })
    },
    track () {
      _paq.push(['setCustomUrl', this.$route.fullPath]);
      _paq.push(['setDocumentTitle', this.category.name]);
      _paq.push(['trackPageView']);
    }
  }
};
</script>


<style scoped>

</style>
